import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';

import { BottomNavComponent } from './shared/bottom-nav/bottom-nav.component';
import { ConfirmDialogHostComponent } from './shared/confirm-dialog/confirm-dialog-host.component';
import { InstallPromptComponent } from './shared/install-prompt/install-prompt.component';
import { SnackbarHostComponent } from './shared/snackbar/snackbar-host.component';

@Component({
  selector: 'app-root',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    RouterOutlet,
    InstallPromptComponent,
    SnackbarHostComponent,
    ConfirmDialogHostComponent,
    BottomNavComponent,
  ],
  templateUrl: './app.html',
})
export class App {}
